app.component("userDetails", {
    templateUrl: "app/src/js/components/userDetails/userDetails.html",
    controller: "userDetailsController",
});

// Practice-scoped view. Shares the controller with userDetails so the practice
// lookup and SMS audit logic live in one place. The practice comes from the rail.
app.component("practiceDetails", {
    templateUrl: "app/src/js/components/userDetails/practiceDetails.html",
    controller: "userDetailsController",
    bindings: { practiceId: "<" },
});

app.controller("userDetailsController", [
    "$scope",
    "Session",
    "PracticeService",
    "$modal",
    "AuthService",
    "ENV",
    "CurrentPatient",
    "$state",
    "AppointmentTimerService",
    "$window",
    "UserService",
    "$timeout",
    "$element",
    "REFERRALS_PATHWAY_1028",
    "PREMIUM_USER_STRIPE_FEATURE_1040",
    "countryConfig",
    function ($scope, Session, PracticeService, $modal, AuthService, ENV, CurrentPatient, $state, AppointmentTimerService, $window, UserService, $timeout, $element, REFERRALS_PATHWAY_1028, PREMIUM_USER_STRIPE_FEATURE_1040, countryConfig) {
        const DATE_FORMAT = "DD/MMM/YYYY";

        this.$onInit = function () {
            $scope.Session = Session;
            $scope.selectedPractice = null;
            $scope.practiceDetail = null;
            $scope.practiceFeatures = [];
            $scope.AS = AuthService;
            $scope.ATS = AppointmentTimerService;
            $scope.CP = CurrentPatient;
            $scope.US = UserService;
            const user = $scope.Session.user;
            $scope.fullName = `${user.title} ${user.firstName} ${user.lastName}`;
            $scope.email = user.email;
            $scope.userRole = (user.roles || []).join(", ");
            $scope.userFeatures = readUserFeatures(user.features);
            $scope.hpicpn = user.hpi_practitioner_number;
            $scope.hpiEdit = { value: $scope.hpicpn };
            $scope.practices = $scope.Session.practiceOptions;
            $scope.PracticeService = PracticeService;
            $scope.smsAuditRange = null;
            $scope.data = null;
            $scope.requestPwResetForm = {};
            $scope.premiumUserPricingTableId = ENV.STRIPE_PREMIUM_USER_PRICING_ID;
            $scope.premiumUserPricingTableKey = ENV.STRIPE_PREMIUM_USER_PRICING_KEY;
            $scope.premiumUserPricingCustomerPortal = ENV.STRIPE_PREMIUM_USER_CUSTOMER_PORTAL;
            $scope.premiumUserStripeFeatureEnabled = PREMIUM_USER_STRIPE_FEATURE_1040;
            $scope.requestPwResetForm = {};
            $scope.windowTimer = null;
            $scope.referralsPathwayEnabled = REFERRALS_PATHWAY_1028;
            $scope.maxNumberOfListedReferralTypes = Session.user.features.maxNumberOfListedReferralTypes;

            if (["OPHTHALMOLOGIST"].some((t) => Session.user.roles.includes(t))) {
                $scope.userIsOpthalmologist = true;
            }

            if (["OPTOMETRIST"].some((t) => Session.user.roles.includes(t))) {
                $scope.userIsOptometrist = true;
            }

            // The rail decides which practice this view shows; fall back to the session
            // practice for the profile view, which has no rail practice of its own.
            const railPracticeId = this.practiceId;
            const initialPracticeId = railPracticeId || (Session.practice && Session.practice.id);

            if (initialPracticeId && $scope.practices && $scope.practices.some((t) => t.id === initialPracticeId)) {
                $scope.selectedPractice = initialPracticeId;
                $scope.practiceOnChange();
            }

            // The date range picker is a jQuery plugin, so it can only be wired up once the
            // template is in the DOM. Only the practice view renders the input.
            $timeout(initDateRangePicker);
        };

        this.$onDestroy = function () {
            if ($scope.windowTimer) {
                clearInterval($scope.windowTimer);
                $scope.windowTimer = null;
            }
        }

        // Scoped to this component - other views use the same input name. The input only
        // exists once a practice with SMS reminders is selected, so this may be a no-op
        // until then.
        let dateRangePickerReady = false;

        function initDateRangePicker() {
            if (dateRangePickerReady) {
                return;
            }

            const input = $element.find('input[name="daterange"]');
            if (!input.length || typeof input.daterangepicker !== "function") {
                return;
            }

            dateRangePickerReady = true;

            const start = moment().subtract(29, "day");
            const end = moment();

            // The picker writes straight into the input, which Angular only picks up if
            // a change event happens to fire - which is why choosing a range never
            // refreshed the chart. Take the dates from the callback instead.
            input.daterangepicker(
                {
                    opens: "left",
                    startDate: start,
                    endDate: end,
                    locale: { format: DATE_FORMAT },
                },
                function (pickedStart, pickedEnd) {
                    $scope.$applyAsync(function () {
                        $scope.smsAuditRange = `${pickedStart.format(DATE_FORMAT)} - ${pickedEnd.format(DATE_FORMAT)}`;
                        $scope.fetchSMSAudit();
                    });
                }
            );

            $scope.smsAuditRange = `${start.format(DATE_FORMAT)} - ${end.format(DATE_FORMAT)}`;
            $scope.fetchSMSAudit();
        }

        $scope.changeEmail = function () {
            $scope.popoverOpened1 = false;
            $scope.requestSent = false;
            $scope.verifySuccess = false;
            $scope.changeEmailModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.change-email.tpl.html",
                show: true,
                backdrop: "static",
                keyboard: false,
                title: "Current email: " + $scope.Session.user.userName,
            });
        };

        $scope.changeHpiCpn = () => {
            $scope.hpiEdit.value = $scope.hpicpn;
            $scope.isEditingHpi = true;
        };
        $scope.confirmHPI = () => {
            const previous = $scope.hpicpn;
            $scope.hpicpn = $scope.hpiEdit.value;
            $scope.isEditingHpi = false;

            //Send Updated HpiCon to User Settings Endpoint
            $scope.US.updateUserSettings({
                hpi_practitioner_number: $scope.hpicpn
            })
            .then((resp) => {
                Session.user.hpi_practitioner_number = $scope.hpicpn;
            }, (error) => {
                // Not saved - put the old number back rather than showing one that isn't stored.
                $scope.hpicpn = previous;
                $scope.serverErrorModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                    show: true,
                    title: "CatTrax has encountered an error",
                });
            })
            .then(() => {
                $scope.US.isProcessing = false;
            })
        }
        $scope.cancelHPI = () => {
            $scope.isEditingHpi = false;
        }

        $scope.closeChangeEmailModal = function () {
            if ($scope.changeEmailModal) {
                $scope.changeEmailModal.hide();
            }
            if ($scope.verifySuccess) {
                logout();
            }
        }

        $scope.verifyEmail = function (email) {
            $scope.AS.isProcessing = true;
            $scope.AS.updateEmail(email).then(function (resp) {
                $scope.requestSent = true;
            }, function (error) {
                console.error("Email update failed", error && error.status);
                $scope.serverErrorModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                    show: true,
                    title: "CatTrax has encountered an error",
                });
            }).then(function () {
                $scope.AS.isProcessing = false;
            })
        }

        $scope.verifyCode = function (code) {
            $scope.AS.isProcessing = true;
            $scope.AS.verifyEmail(code).then(function (resp) {
                $scope.requestSent = false;
                $scope.verifySuccess = true;
            }, function (error) {
                console.error("Email verification failed", error && error.status);
                $scope.serverErrorModal = $modal({
                    scope: $scope,
                    templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                    show: true,
                    title: "CatTrax has encountered an error",
                });
            }).then(function () {
                $scope.AS.isProcessing = false;
            })
        }

        function delay(milliseconds) {
            return new Promise(resolve => {
                setTimeout(resolve, milliseconds);
            });
        }

        async function logout() {
            if ($scope.changeEmailModal) {
                $scope.changeEmailModal.hide();
            }
            $scope.CP.clearPatient();
            await delay(500);
            $scope.ATS.stopTimer();
            try {
                await $scope.AS.logout();
            } catch (error) {
                // Clear local session even if server logout fails.
            }
            Session.destroy();
            $state.go('login');
        }

        $scope.options = {
            chart: {
                type: 'lineChart',
                height: 320,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 65,
                    left: 50
                },
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                color: ['#0035d2'],
                // Drives both the axis ticks and the hover guideline header.
                useInteractiveGuideline: true,
                xAxis: {
                    axisLabel: 'Date',
                    // d3's %x is US-locale, so spell the NZ order out.
                    tickFormat: function (d) {
                        return d3.time.format('%d/%m/%Y')(new Date(d))
                    },
                    rotateLabels: 30,
                    showMaxMin: false
                },
                yAxis: {
                    axisLabel: 'SMS sent',
                    axisLabelDistance: -10,
                    tickFormat: function (d) {
                        return d;
                    }
                }
            }
        };

        $scope.practiceOnChange = function () {
            $scope.practiceDetail = $scope.practices.find((t) => t.id === $scope.selectedPractice);
            $scope.practiceFeatures = $scope.practiceDetail ? readPracticeFeatures($scope.practiceDetail.practiceFeatures) : [];
            $scope.data = null;
            $scope.fetchSMSAudit();
            // The chart card may have only just appeared for this practice.
            $timeout(initDateRangePicker);
        };

        // Names are only listed here where the derived one would be wrong: proper nouns,
        // acronyms, and wording the practices already recognise. Anything else falls back
        // to humaniseFeatureKey, so a new flag from the API still reads properly.
        const USER_FEATURE_NAMES = {
            injectionNoteFeature: "Injection notes",
            editableSystemTranscriptionPromptsFeature: "Editable transcription prompts",
        };

        const PRACTICE_FEATURE_NAMES = {
            nhiFeature: "NHI",
            fhirNhiFeature: "FHIR NHI",
            billingInvoiceGSTInclusiveFeature: "GST inclusive invoices",
            appointmentEmailReminderFeature: "Appointment email reminders",
            appointmentSMSReminderFeature: "Appointment SMS reminders",
            documentNotificationFeature: "Document notifications",
            patientCustomFormsFeature: "Patient custom forms",
            customPdfHeadersFeature: "Custom PDF headers",
            elevenLabsAiAgentFeature: "AI agent",
            snomedAiExtractionFeature: "SNOMED AI extraction",
            dicomFeature: "DICOM",
            inventoryFeature: "Inventory",
            lensDispensingFeature: "Lens prescribing & dispensing",
            tyroTerminalFeature: "Tyro terminal payments",
            patientContactVerificationFeature: "Patient contact verification",
            progressNoteSettings: "Progress note settings",
        };

        // dataExportFeature -> "Data export", appointmentSMSReminder -> "Appointment SMS reminder".
        // Words that are already all caps are left alone so acronyms survive.
        function humaniseFeatureKey(key) {
            return key
                .replace(/Feature$/, "")
                .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
                .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
                .trim()
                .split(" ")
                .map((word, index) => {
                    if (word.length > 1 && word === word.toUpperCase()) {
                        return word;
                    }
                    const lower = word.toLowerCase();
                    return index === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
                })
                .join(" ");
        }

        function readFeatures(features, names, isEnabled, hidden) {
            return Object.keys(features || {})
                .filter((key) => (hidden || []).indexOf(key) === -1)
                .filter((key) => isEnabled(features[key]))
                .map((key) => names[key] || humaniseFeatureKey(key))
                .sort((a, b) => a.localeCompare(b));
        }

        function readUserFeatures(userFeatures) {
            return readFeatures(userFeatures, USER_FEATURE_NAMES, (value) => value === true);
        }

        // Features that are not a practice's to have in this country, so listing them either way says
        // something untrue. GST inclusive invoicing is pinned on in Australia - consumer law requires a price
        // quoted to a patient to include GST - so a practice whose stored flag happens to read false would be
        // shown as not having it when every invoice it raises is inclusive regardless.
        const HIDDEN_PRACTICE_FEATURES = countryConfig.countryCode === "AU"
            ? ["billingInvoiceGSTInclusiveFeature"]
            : [];

        // Only list features that are actually switched on. Booleans set to false, and
        // non-feature values such as trial dates, are left out.
        function readPracticeFeatures(practiceFeatures) {
            return readFeatures(
                practiceFeatures,
                PRACTICE_FEATURE_NAMES,
                (value) => value === true || (value !== null && typeof value === "object"),
                HIDDEN_PRACTICE_FEATURES
            );
        }

        $scope.subscribePremiumUser = function () {
            var iframe =
                '<script async src="https://js.stripe.com/v3/pricing-table.js"></script><html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body>' +
                `<stripe-pricing-table pricing-table-id="${$scope.premiumUserPricingTableId}" publishable-key="${$scope.premiumUserPricingTableKey}" customer-email="${$scope.email}"></stripe-pricing-table></body></html>`

            var windowWidth = 640;
            var windowHeight = 480;

            var screenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
            var screenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

            var screenWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
            var screenHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;

            var left = screenLeft + (screenWidth - windowWidth) / 2;
            var top = screenTop + (screenHeight - windowHeight) / 2;

            var win = $window.open("", "", `width=${windowWidth},height=${windowHeight},top=${top},left=${left},toolbar=no,menubar=no,resizable=yes`);

            win.document.write(iframe);
            if ($scope.windowTimer) {
                clearInterval($scope.windowTimer);
            }
            $scope.windowTimer = setInterval(function () {
                if (win.closed) {
                    clearInterval($scope.windowTimer);
                    $scope.windowTimer = null;
                    requestPremiumUser();
                }
            }, 1000);
        };

        function requestPremiumUser() {
            $scope.US.isProcessing = true;
            $scope.US.getUser()
                .then(
                    function (resp) {
                        $scope.userFeatures = readUserFeatures(resp.data.features);
                        $scope.Session.user.features = resp.data.features;
                    },
                    function (e) {
                        console.error("Failed to refresh user", e && e.status);
                    }
                )
                .then(() => ($scope.US.isProcessing = false));
        }

        $scope.fetchSMSAudit = function () {
            if (!$scope.selectedPractice || !$scope.smsAuditRange) {
                return;
            }
            const duration = $scope.smsAuditRange.split("-");
            // Parse with the picker's own format (moment would otherwise fall back to browser Date
            // parsing), and run to the end of the last day so it is included.
            const start_date_UTC = moment(duration[0].trim(), DATE_FORMAT).startOf("day").utc().toISOString();
            const end_date_UTC = moment(duration[1].trim(), DATE_FORMAT).endOf("day").utc().toISOString();
            $scope.PracticeService.isProcessing = true;

            $scope.PracticeService.querySMSAudit($scope.selectedPractice, start_date_UTC, end_date_UTC)
                .then(
                    function (response) {
                        $scope.data = [
                            {
                                key: "SMS sent",
                                // The API sends DD/MM/YY, which moment would otherwise
                                // fall back to parsing as a US date.
                                values: response.data.chart_data[0].chart_data_points.map((t) => {
                                    return [moment(t.x, "DD/MM/YY").utc().valueOf(), t.y];
                                }),
                            },
                        ];
                        if ($scope.data.length > 0 && $scope.data[0].values.length > 0) {
                            $scope.options.chart = {
                                ...$scope.options.chart,
                                xDomain: [
                                    $scope.data[0].values[0][0] - 10000,
                                    $scope.data[0].values[$scope.data[0].values.length - 1][0] + 10000,
                                ],
                            };
                        }
                    },
                    function (error) { }
                )
                .then(() => ($scope.PracticeService.isProcessing = false));
        };


    },
]);
